const VaultKeys = {
  OPNALPHA: "op-nALPHA",
  OPNBASIS: "op-nBASIS",
  OPNETF: "op-nETF",
  OPNPAYFI: "op-nPAYFI",
  OPNPLUME: "op-PLUME",
  OPNRWA: "op-nRWA",
  OPNTBILL: "op-nTBILL",
  OPPUSD: "op-pUSD",
  XLHYPE: "XLHYPE"
};
export {
  VaultKeys
};
//# sourceMappingURL=config.mjs.map